import React, { Component } from "react";

// Bootstrap
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";

class NotFound extends Component {
  componentDidMount() {
    const root = document.getElementById("root");
    root.className = "";
    document.body.style.backgroundColor = "#fff";
  }

  componentWillUnmount() {
    document.body.style.backgroundColor = "#f4f7fb";
  }

  render() {
    return (
      <Container className="vh-100 d-flex align-items-center justify-content-around">
        <Row className="w-100">
          <Col md={8} lg={6} className="mx-auto px-0">
            <h2 className="font-weight-black text-primary mb-0">404</h2>
            <h3 className="h2 font-weight-bold mb-1">Page not found</h3>
            <p className="mb-5">
              We couldn't find the page you were looking for. If you think this is an issue please reach out to us at <a href="mailto:support@jointracker.com">support@jointracker.com</a>.
            </p>

            <a href="/" className="btn bg-primary text-white shadow-none d-block font-weight-medium mt-3">
              Go Home
            </a>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default NotFound;
